import { ButtonIcon, DuplicateIcon, Tooltip } from 'canoe';
import React from 'react';

import { TooltipBodyWithShortcuts } from 'craft/components/TooltipBodyWithShortcuts';

export const DuplicateButton = ({
  tooltipPlacement,
  onClick,
}: {
  tooltipPlacement: 'top' | 'bottom';
  onClick: VoidFunction;
}) => {
  return (
    <Tooltip
      placement={tooltipPlacement}
      offset="xxs"
      content={<TooltipBodyWithShortcuts content="Duplicate" />}
    >
      <ButtonIcon
        size="small"
        icon={DuplicateIcon}
        onClick={onClick}
        radius="small"
        color="white"
      />
    </Tooltip>
  );
};
